import React from 'react';
import ReactDOM from 'react-dom/client'; // Gebruik 'react-dom/client' voor createRoot
import "bootstrap/dist/css/bootstrap.min.css";
import './index.scss';
import App from './App';
import { toast } from "react-toastify";

import { BrowserRouter } from 'react-router-dom';

import config from './config';

import "bootstrap/dist/js/bootstrap.bundle.js";

import * as serviceWorkerRegistration from './serviceWorker';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './keycloak';
import { ErrorContextProvider } from './contexts/ErrorContext';

const baseUrl = config.app.redirectUri;

const onEvent = (event) => {
  if (event === "onReady" && !keycloak?.token) {
    keycloak.login({ idpHint: config.app.authIdpHint });
  }
};

const onKeycloakTokens = (tokens) => {
  if (!tokens.token) {
    keycloak.login({ idpHint: config.app.authIdpHint });
  }
};

const updateToastId = "app-update-available";
let hasRefreshedForServiceWorker = false;

function applyServiceWorkerUpdate(registration) {
  if (!registration?.waiting) {
    return;
  }

  localStorage.setItem("reload-localstorage", "true");
  registration.waiting.postMessage({ type: "SKIP_WAITING" });
}

function showServiceWorkerUpdateToast(registration) {
  if (!registration?.waiting || toast.isActive(updateToastId)) {
    return;
  }

  const toastText = (
    <p onClick={() => applyServiceWorkerUpdate(registration)} className="toast-content-encompass">
      A new update is available, click this notification to install the update.
    </p>
  );

  toast.info(toastText, {
    toastId: updateToastId,
    autoClose: false,
    draggable: false,
    pauseOnFocusLoss: false
  });
}

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (hasRefreshedForServiceWorker) {
      return;
    }

    hasRefreshedForServiceWorker = true;
    window.location.reload();
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter basename={baseUrl}>
    <ReactKeycloakProvider authClient={keycloak} onTokens={onKeycloakTokens} onEvent={onEvent}>
      <ErrorContextProvider>
        <App />
      </ErrorContextProvider>
    </ReactKeycloakProvider>
  </BrowserRouter>
);

serviceWorkerRegistration.register({
  onUpdate: showServiceWorkerUpdateToast
});
